import React, { PureComponent } from 'react';
import View from './data_collection_rules/view';
import ruleFetcher from '../utils/rule_fetcher';
import { DataCollectionRulesContext } from './data_collection_rules/context';
import type { Context } from './data_collection_rules/context';
import { create, read, update, destroy } from '../utils/request';

type Props = {
  rulesPath: string;
  emailTemplatePath: string;
};

export default class DataCollectionRules extends PureComponent<Props, Context> {
  state: Context = {
    edited: false,
    editing: false,
    editingRuleId: null,
    errors: {},
    loaded: false,
    rules: [],
    meta: {
      all_offices_path: '',
      candidate_data_path: '',
      notifications_path: '',
      update_rules_path: '',
      new_rule_path: '',
      pagination: {
        current_page: null,
        next_page: null,
        per_page: null,
        previous_page: null,
        total_entries: null,
        total_pages: null,
      },
    },
    onAdd: async () => {
      const response = await read(this.state.meta.new_rule_path);
      this.setState((prevState) => ({
        rules: [...prevState.rules, { ...response.data, enabled: true }],
        editing: true,
        editingRuleId: response.data.id,
      }));
    },
    onCancel: () =>
      this.setState((prevState) => ({
        editing: false,
        edited: false,
        editingRuleId: null,
        errors: {},
        rules: prevState.rules.filter((r) => r.id !== null),
      })),
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    onEdit: (rule) =>
      this.setState({
        editing: true,
        editingRuleId: rule.id,
        errors: {},
      }),
    // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    onFieldChange: (field) =>
      this.setState((prevState) => ({
        edited: true,
        errors: { ...prevState.errors, [field]: null },
      })),
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    onSave: async (rule) => {
      try {
        // @ts-expect-error - TS7034 - Variable 'response' implicitly has type 'any' in some locations where its type cannot be determined.
        let response;
        if (!rule.id) {
          response = await create(this.state.meta.update_rules_path, rule, {
            scope: 'data_collection_rule',
          });
        } else {
          response = await update(this.state.meta.update_rules_path, rule, {
            scope: 'data_collection_rule',
          });
        }
        this.setState((prevState) => {
          const { rules } = prevState;
          const updatedRuleIndex = rules.findIndex((r) => r.id === rule.id);
          // @ts-expect-error - TS7005 - Variable 'response' implicitly has an 'any' type.
          rules.splice(updatedRuleIndex, 1, response.data);

          return {
            editing: false,
            edited: false,
            editingRuleId: null,
            rules,
          };
        });
      } catch (error: any) {
        const {
          response: {
            data: { errors },
          },
        } = error;

        this.setState({
          errors,
        });
      }
    },
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    onDelete: async (rule) => {
      await destroy(this.state.meta.update_rules_path, rule);
      this.setState((prevState) => {
        const rules = prevState.rules.filter((r) => r.id !== rule.id);

        return {
          rules,
          editing: false,
          editingRuleId: null,
        };
      });
    },
  };

  componentDidMount(): void {
    const { rulesPath } = this.props;
    // @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7006 - Parameter 'done' implicitly has an 'any' type.
    ruleFetcher(rulesPath, ({ data }, done) =>
      this.setState((prevState) => ({
        loaded: done,
        meta: data.meta,
        rules: [...prevState.rules, ...data.rules],
      }))
    );
  }

  render() {
    const { emailTemplatePath } = this.props;

    return (
      <DataCollectionRulesContext.Provider value={this.state}>
        <View emailTemplatePath={emailTemplatePath} />
      </DataCollectionRulesContext.Provider>
    );
  }
}
